{
	"countries": [
		{
			"link": "austria",
			"name": "Austria",
			"icon": "at",
			"has_sub_categories": true
		},
		{
			"link": "belgium",
			"name": "Belgium",
			"icon": "be",
			"has_sub_categories": true
		},
		{
			"link": "czech-republic",
			"name": "Czech Republic",
			"icon": "cz",
			"has_sub_categories": true
		},
		{
			"link": "denmark",
			"name": "Denmark",
			"icon": "dk",
			"has_sub_categories": true
		},
		{
			"link": "france",
			"name": "France",
			"icon": "fr",
			"has_sub_categories": true
		},
		{
			"link": "germany",
			"name": "Germany",
			"icon": "de",
			"has_sub_categories": true
		},
		{
			"link": "hungary",
			"name": "Hungary",
			"icon": "hu",
			"has_sub_categories": true
		},
		{
			"link": "italy",
			"name": "Italy",
			"icon": "it",
			"has_sub_categories": true
		},
		{
			"link": "latvia",
			"name": "Latvia",
			"icon": "lv",
			"has_sub_categories": true
		},
		{
			"link": "lithuania",
			"name": "Lithuania",
			"icon": "lt",
			"has_sub_categories": true
		},
		{
			"link": "luxembourg",
			"name": "Luxembourg",
			"icon": "lu",
			"has_sub_categories": true
		},
		{
			"link": "netherlands",
			"name": "Netherlands",
			"icon": "nl",
			"has_sub_categories": true
		},
		{
			"link": "poland",
			"name": "Poland",
			"icon": "pl",
			"has_sub_categories": true
		},
		{
			"link": "northern-ireland",
			"name": "Northern Ireland",
			"icon": "gb-nir",
			"has_sub_categories": false
		},
		{
			"link": "romania",
			"name": "Romania",
			"icon": "ro",
			"has_sub_categories": true
		},
		{
			"link": "spain",
			"name": "Spain",
			"icon": "es",
			"has_sub_categories": true
		},
		{
			"link": "sweden",
			"name": "Sweden",
			"icon": "se",
			"has_sub_categories": true
		}
	],

	"flowersCountries": ["Austria", "Belgium", "Czech Republic", "Denmark", "France", "Germany", "Hungary", "Italy", "Latvia", "Lithuania", "Luxembourg", "Netherlands", "Poland", "Northern Ireland", "Romania", "Spain", "Sweden"],

	"hampersCountries": ["Netherlands", "Belgium", "France", "Luxembourg", "Germany", "Denmark", "Spain", "Italy", "Poland", "Hungary", "Sweden"]
}
